<template>
  <div class="m-worker-comment">
    <b-modal
      id="worker-comment-modal"
      v-model="isActive"
      size="custom-size"
      centered
      hide-footer
      hide-header
      @shown="onShown"
      @hidden="$emit('close')"
    >
      <svg
        class="m-worker-comment-close"
        width="15"
        height="16"
        viewBox="0 0 15 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        @click="$emit('close')"
      >
        <path
          d="M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z"
          fill="#8E9CBB"
        />
        <path
          d="M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z"
          fill="#8E9CBB"
        />
      </svg>
      <div class="m-worker-comment-title">
        <template v-if="comment"> Изменить комментарий </template>
        <template v-else> Добавить комментарий </template>
      </div>

      <c-textarea
        ref="commentTextArea"
        v-model="form.comment"
        class="finance-transaction-modal-personal-account-comment"
        type="textarea"
        :clearable="true"
        floating-label="Текст комментария"
        :required="commentErrorMessage"
        :error="commentErrorMessage"
        :invalid="commentErrorMessage"
        max-length="500"
      />
      <div>
        <div class="m-worker-comment-buttons">
          <c-button class="m-worker-comment-buttons-close" label="Отменить" @click="$emit('close')" />
          <c-button
            color="primary"
            class="m-worker-comment-buttons-save"
            label="Сохранить"
            @click="handleCommentSave"
          />
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Button from "@/components/controls2/Button";
import CTextarea from "@/components/controls/textarea";

export default {
  name: "worker-comment-modal",
  components: {
    "c-button": Button,
    CTextarea,
  },
  props: {
    comment: {
      type: String,
      default: "",
    },
    handleSaveOutside: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isActive: true,
      commentErrorMessage: "",
      submitAttempt: false,
      form: {
        comment: undefined,
      },
    };
  },
  watch: {
    "comment": function (value) {
      this.form.comment = value;
    },
    "form.comment": function (value) {
      if (this.submitAttempt) {
        if (!value) {
          this.commentErrorMessage = "Обязательное поле";
        } else {
          this.commentErrorMessage = "";
        }
      }
    },
  },
  mounted() {
    this.form.comment = this.comment;
  },

  methods: {
    ...mapActions("personalEmployee", ["saveWorkersComment"]),
    async handleCommentSave() {
      const cleanValue = this.form.comment.replace(/^\s+/, "").replace(/\s+$/, "");

      if (!cleanValue) {
        this.$emit("close");
      }

      if (this.handleSaveOutside) {
        this.$emit("on-save", cleanValue);
        this.$emit("close");
        return;
      }

      let isValidForm = true;

      if (!this.form.comment) {
        this.submitAttempt = true;
        this.commentErrorMessage = "Обязательное поле";
        isValidForm = false;
      }

      if (isValidForm) {
        const { id } = this.$route.params;
        await this.saveWorkersComment({ id, comment: cleanValue });
        this.$emit("close");
      }
    },
    onShown() {
      this.$refs.commentTextArea.setTextareaHeight();
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.finance-transaction-modal-personal-account-comment {
  flex-grow: 1;
  overflow: hidden;

  @include onlyMobile {
    padding-bottom: 40px;
  }
}

.m-worker-comment {
  position: relative;

  &-close {
    cursor: pointer;
    position: absolute;
    top: 12px;
    right: 10px;
  }

  &-title {
    font-weight: 500;
    font-size: 18px;
    line-height: 120%;
    margin-bottom: 1rem;

    @media screen and (max-width: 700px) {
      font-size: 15px;
      line-height: 120%;
      margin-bottom: 26px;
    }
  }

  &-buttons {
    margin-top: 29px;
    display: flex;
    justify-content: flex-end;
    align-self: center;

    @media screen and (max-width: 700px) {
      width: 100%;
      position: fixed;
      bottom: 0;
      left: 0;
    }

    &-close {
      max-width: 120px;

      @media screen and (max-width: 700px) {
        max-width: 50%;
        width: 50%;
        border-radius: 0;
        border-left: none;
        border-bottom: none;
      }
    }

    &-save {
      margin-left: 10px;
      max-width: 125px;

      @media screen and (max-width: 700px) {
        max-width: 50%;
        margin-left: 0;
        width: 50%;
        border-radius: 0;
        border-left: none;
        border-bottom: none;
      }
    }
  }
}
</style>
